module.exports = __webpack_public_path__ + "static/img/day2.e384c32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour2/day2.jpg
// module id = o+++
// module chunks = 0